$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Email Signup 
  const $emailSignup = $('.emailSignup');
  $emailSignup.find('.inputFieldTextbox').val('');
  $emailSignup.find('.inputFieldTextbox').attr('placeholder', 'Enter Email...');
  $emailSignup.find('.emailSignupText').html("JOIN OUR NEWSLETTER");
  $emailSignup.find('.emailInputSubmit a').html("SIGN UP");

  // Feature Lineup
  $('.featureLineup-buynow .button').text('BUY NOW');
  $('.featureLineup-text').each(function () {
    var text = $(this).text();
    if (text.length > 200) {
      $(this).text(text.substring(0, 110) + '...');
    }
  });
});

$(window).load(function () {
  // setTimeout(function () {
  //   if ($('body').hasClass('siteInfoBannerWidgetDateIsPast')) {
  //     $('.counter-container').remove();
  //   }

  //   // Countdown Date
  //   $('#eventName .countdownDays').remove();
  //   const $eventName = $("#siteInfoBannerWidget #eventName");
  //   const $eventDates = $("#siteInfoBannerWidget #eventDates");

  //   if ($eventName.length > 0) {
  //     // catch title value
  //     const eventTitle = $eventName.text();
  //     // create the svg curve and the title as a string value
  //     const svg = `<svg x="0px" y="0px"
  //       viewBox="0 0 498.6 39.9" xml:space="preserve">
  //         <path id="newcurve" d="M0,32.1c0,0,106.4-22.5,241-22.5s254.3,22.5,254.3,22.5"/>
  //           <text width="800">
  //           <textPath startOffset="50%" xlink:href="#newcurve">
  //         ${eventTitle}
  //       </textPath>
  //     </text>
  //   </svg>`;
  //     // append the svg as html inside the div content
  //     $eventName.html(svg);
  //   }

  //   if ($eventDates.length > 0) {
  //     // catch title value
  //     const eventDateText = $eventDates.text();
  //     // create the svg curve and the title as a string value
  //     const svgtext = `<svg x="0px" y="0px"
  //       viewBox="0 0 498.6 39.9" xml:space="preserve">
  //         <path id="newcurves" d="M0,32.1c0,0,106.4-22.5,241-22.5s254.3,22.5,254.3,22.5"/>
  //           <text width="800">
  //           <textPath startOffset="50%" xlink:href="#newcurves">
  //         ${eventDateText}
  //       </textPath>
  //     </text>
  //   </svg>`;
  //     // append the svg as html inside the div content
  //     $eventDates.html(svgtext);
  //   }
  // }, 1000); // 1000 milliseconds = 1 second

  let submitEmail = $('#signup-container .emailSignup .inputFieldSubmit');
  let inputEmail = $('#signup-container .emailSignup input');
  $('#signup-container .emailSignup .emailSignupText').remove();
  $('#signup-container .emailSignup .emailInputField').prepend(`
    <div id="coupon-box">
      <span>Get free admission ticket</span>
      <span>Enter email to subscribe & download!</span>
    </div>
  `);
  $('#signup-container .emailSignup .emailInputSubmit .inputFieldSubmit ').text('Submit');

  // Input email enter event
  $(inputEmail).keydown(function (event) {
    if (event.key == 'Enter') {
      submitForm();
    }
  });

  // Click event
  $(submitEmail).on('keypress click', function (event) {
    if (event.key == 'Enter' || event.type == 'click') {
      submitForm();
    }
  });

  // Launch ticket function
  function submitForm() {
    let validationInProgress = true;
    setTimeout(function () {
      validationInProgress = false;
    }, 2000);

    let validationInterval = setInterval(function () {
      if (!validationInProgress) {
        clearInterval(validationInterval);
        return;
      }

      if ($('body').hasClass('hideBackToTop')) {
        let documentName = '2024 Fair Coupon.pdf'; // Ticket file name
        let pdfCoupon = `${FULLCLIENTTHEMEPATH}images/${documentName}`; // Ticket file path

        clearInterval(validationInterval);
        $('body').append(`<div class="coupon-opening">Free admission ticket opening in <span id="seconds">5</span> seconds...</div>`);
        countdown(4);
        setTimeout(() => {
          window.open(pdfCoupon, '_blank');
          $('.coupon-opening').remove();
        }, 6000);
      }
    }, 100);
  }

  // Countdown for opening PDF
  function countdown(seconds) {
    const countdownDiv = document.getElementById('seconds');
    let timer = setInterval(() => {
      countdownDiv.textContent = seconds;
      seconds--;

      if (seconds < 0) {
        clearInterval(timer);
      }
    }, 1000);
  }
});
